import { useState, useEffect, useCallback } from "react";
import {
  detectPreferredLocale,
  SUPPORTED_LOCALES,
  DEFAULT_LOCALE
} from "../utils/locale";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/es";
import "dayjs/locale/pt";
function useLocale() {
  const [locale, setLocaleState] = useState(() => detectPreferredLocale());
  const setLocale = useCallback((l) => {
    const normalized = String(l || "").split("-")[0].toLowerCase();
    const chosen = SUPPORTED_LOCALES.includes(normalized) ? normalized : DEFAULT_LOCALE;
    setLocaleState(chosen);
    try {
      localStorage.setItem("locale", chosen);
    } catch (e) {
    }
    try {
      window.dispatchEvent(
        new CustomEvent("localeChanged", { detail: chosen })
      );
      if (typeof window !== "undefined" && window.location) {
        setTimeout(() => window.location.reload(), 50);
      }
    } catch (e) {
    }
  }, []);
  useEffect(() => {
    try {
      localStorage.setItem("locale", locale);
    } catch (e) {
    }
  }, [locale]);
  useEffect(() => {
    try {
      dayjs.locale(locale);
    } catch (e) {
    }
  }, [locale]);
  return { locale, setLocale, supported: SUPPORTED_LOCALES };
}
export {
  useLocale as default
};
